/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//设置城市列表
const setCityList = ({ dispatch, state }, list) => {
  return dispatch('SET_CITY_LIST', list);
}

//设置话题列表
const setTopicList = ({ dispatch, state }, list) => {
  return dispatch('SET_TOPIC_LIST', list);
}

//设置品牌列表
const setBrandList = ({ dispatch, state }, list) => {
  return dispatch('SET_BRAND_LIST', list);
}

module.exports = {
  setCityList,
  setTopicList,
  setBrandList
}




// WEBPACK FOOTER //
// ./src/appBackend/vuex/action/common.js